import React, { useState, useEffect } from 'react';
import { MessageCircle, X } from 'lucide-react';

const WhatsAppBtn = () => {
  const [isVisible, setIsVisible] = useState(true);
  const [showTooltip, setShowTooltip] = useState(false);

  useEffect(() => {
    // Show tooltip after 3 seconds
    const timer = setTimeout(() => {
      setShowTooltip(true);
      // Hide tooltip after 5 more seconds
      setTimeout(() => setShowTooltip(false), 5000);
    }, 3000);

    return () => clearTimeout(timer);
  }, []);

  const handleWhatsAppClick = () => {

    const message = encodeURIComponent("Hello! I would like to get a quote for AC services.");
    window.open(`https://wa.me/97474408801?text=${message}`, '_blank');
  };

  if (!isVisible) return null;

  return (
    <div className="fixed bottom-6 right-6 z-50" onClick={()=>{
    const message = encodeURIComponent("Hello! I would like to get a quote for AC services.");
    window.open(`https://wa.me/97474408801?text=${message}`, '_blank');
    }}>
      {/* Tooltip */}
      {showTooltip && (
        <div className="absolute bottom-20 right-0 bg-white shadow-2xl rounded-xl p-4 mb-2 border border-gray-200 animate-bounce">
          <div className="text-gray-800 font-semibold text-sm mb-1">Need AC Service?</div>
          <div className="text-gray-600 text-xs">Chat with us on WhatsApp!</div>
          <div className="absolute -bottom-2 right-6 w-4 h-4 bg-white border-r border-b border-gray-200 transform rotate-45"></div>
        </div>
      )}

      {/* WhatsApp Button */}
      <div className="relative cursor-pointer">
        <button
          onClick={handleWhatsAppClick}
          className="bg-green-500 hover:bg-green-600 text-white p-4 rounded-full shadow-2xl transition-all duration-300 transform hover:scale-110 border-4 border-white"
          title="Chat with us on WhatsApp"
        >
          <MessageCircle size={28} />
        </button>
        
        {/* Notification Badge */}
        <div 
         className="absolute -top-2 -right-2 bg-red-500 text-white text-xs font-bold w-6 h-6 rounded-full flex items-center justify-center animate-pulse border-2 border-white">
          1
        </div>
        
        {/* Close Button */}
        <button
          onClick={() => setIsVisible(false)}
          className="absolute -top-2 -left-2 bg-gray-600 hover:bg-gray-700 text-white rounded-full w-6 h-6 flex items-center justify-center transition-colors duration-300 border-2 border-white"
          title="Close"
        >
          <X size={12} />
        </button>
        
        {/* Pulsing ring */}
        <div className="absolute inset-0 bg-green-400 rounded-full animate-ping opacity-20"></div>
      </div>
    </div>
  );
};

export default WhatsAppBtn;